import {
  Component,
  EventEmitter,
  Inject,
  Input,
  OnInit,
  Output,
} from "@angular/core";
import { DialogRef } from "../../../../../../../../shared/partials/dialog/dialog-ref";
import { DIALOG_DATA } from "../../../../../../../../shared/partials/dialog/dialog-tokens";

@Component({
    selector: "app-md-details",
    templateUrl: "./md-details.component.html",
    styleUrls: ["./md-details.component.scss"],
    standalone: false
})
export class MdDetailsComponent implements OnInit {
  @Input() public opened = false;
  @Input() public data: any;
  @Input() public message: any;

  @Output() closeDialogEvent = new EventEmitter<any>();

  public titlebarTitle = "Confirmation";
  public titlebarCssClass = "modal-title-red";
  public dlgWidth: number = 600;
  public dlgMaxHeight: string = "80%";

  constructor(
    private dialogRef: DialogRef,
    @Inject(DIALOG_DATA) public inputData: v1DetailsDlgInputArgs
  ) {}

  ngOnInit(): void {
    if (this.inputData) {
      this.opened = this.inputData.opened;
      this.dlgWidth = this.inputData.dialogWidth;
      this.data = this.inputData.data;
      this.message = this.inputData.message;
    }
  }

  public close(status: any) {
    this.opened = false;

    let savParamters: dlgDetailsModelArgs = {
      status: status,
      data: this.data,
    };
    this.closeDialogEvent.emit(savParamters);
    this.dialogRef?.close(savParamters);
  }

  public open() {
    this.opened = true;
  }
}

export interface v1DetailsDlgInputArgs {
  opened: boolean;
  dialogWidth: number;
  data: any;
  message: any;
}

export interface dlgDetailsModelArgs {
  status: string;
  data: any; //ProposalEntity[]
}
